import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  headerHeight: 48,
  siderWidth: 180,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {
    header: {
      heightLayoutHeader: 48,
    },
    pageContainer: {
      paddingBlockPageContainerContent: 20,
      paddingInlinePageContainerContent: 20,
    },
  },
  splitMenus: true,
  defaultOpenAll: true,
  menu: {
    defaultOpenAll: true,
    autoClose: false,
  },
};
export default Settings;
